module.exports = __webpack_public_path__ + "img/numero-rue.5da04877.png";